// @flow
import { LatLng } from "./simpleTypes";

export interface IPointOfConnectionProperties {
  voltDropPercent: ?number;
  voltRisePercent: ?number;
  loopResistanceMilliohm: ?number;
  includesDownstreamLoad: Boolean;
  includesTransformerResistance: Boolean;
  annotation: string;
  geometry: LatLng;
  styles: any;
  maxVoltDropPercent: ?number;
  maxVoltDropPercentPassResult: Boolean;
  maxVoltRiseTotal: ?number;
  maxVoltRiseGeneration: ?number;
  maxVoltRiseUnbalance: ?number;
  maxVoltRisePercent: ?number;
  earthLoopImpedance: number;
  threePhaseFaultCurrent: number;
  threePhaseFaultCurrentPassResult: Boolean;
  phaseToPhaseFaultCurrent: number;
  phaseToPhaseFaultCurrentPassResult: Boolean;
  singlePhaseToEarthFaultCurrent: number;
  singlePhaseToEarthFaultCurrentPassResult: Boolean;
  flickerPassResult: Boolean;
  flickerDeltaVoltage: number;
  flickerP28Limit: number;
  flickerStartingPassResult: Boolean;
  flickerStartingDeltaVoltage: number;
  impedanceLoopOperating: string;
  impedanceLoopOperatingPassResult: Boolean;
  impedanceSourceLoopOperating: string;
  impedanceSourceLoopOperatingPassResult: Boolean;
  impedanceLoopFault: string;
  impedancePhaseOperating: string;
  impedanceSourcePhaseOperating: string;
  impedanceSourcePhasePhaseOperating: string;
  impedancePhaseFault: string;
  resistanceLoopOperating: string;
  resistanceSourceLoopOperating: string;
  resistanceLoopFault: string;
  resistancePhaseOperating: string;
  resistanceSourcePhaseOperating: string;
  resistanceSourcePhasePhaseOperating: string;
  resistancePhaseFault: string;
  reactanceLoopOperating: string;
  reactanceSourceLoopOperating: string;
  reactanceLoopFault: string;
  reactancePhaseOperating: string;
  reactanceSourcePhaseOperating: string;
  reactanceSourcePhasePhaseOperating: string;
  reactancePhaseFault: string;
  AllmaxVoltDropPercent: ?number;
  AllmaxVoltDropPercentPeriod: ?number;
  AllmaxVoltDropPercentPassResult: Boolean;
  AllmaxVoltDropPhase: ?number;
  AllmaxVoltRiseTotal: ?number;
  AllmaxVoltRiseGeneration: ?number;
  AllmaxVoltRiseUnbalance: ?number;
  AllmaxVoltRisePercent: ?number;
  AllmaxVoltRisePercentPeriod: ?number;
  AllmaxVoltRisePhase: ?number;
  AllmaxVoltage: ?number;
  AllmaxVoltagePhase1: ?number;
  AllmaxVoltagePhase2: ?number;
  AllmaxVoltagePhase3: ?number;
  AllminVoltage: ?number;
  AllminVoltagePhase1: ?number;
  AllminVoltagePhase2: ?number;
  AllminVoltagePhase3: ?number;
  wintermaxVoltDropPercent: ?number;
  wintermaxVoltDropPercentPeriod: ?number;
  wintermaxVoltDropPercentPassResult: Boolean;
  wintermaxVoltDropPhase: ?number;
  wintermaxVoltRisePercent: ?number;
  wintermaxVoltRiseTotal: ?number;
  wintermaxVoltRiseGeneration: ?number;
  wintermaxVoltRiseUnbalance: ?number;
  wintermaxVoltRisePercentPeriod: ?number;
  wintermaxVoltRisePhase: ?number;
  wintermaxVoltage: ?number;
  wintermaxVoltagePhase1: ?number;
  wintermaxVoltagePhase2: ?number;
  wintermaxVoltagePhase3: ?number;
  winterminVoltage: ?number;
  winterminVoltagePhase1: ?number;
  winterminVoltagePhase2: ?number;
  winterminVoltagePhase3: ?number;
  summermaxVoltDropPercent: ?number;
  summermaxVoltDropPercentPeriod: ?number;
  summermaxVoltDropPercentPassResult: Boolean;
  summermaxVoltDropPhase: ?number;
  summermaxVoltRisePercent: ?number;
  summermaxVoltRiseTotal: ?number;
  summermaxVoltRiseGeneration: ?number;
  summermaxVoltRiseUnbalance: ?number;
  summermaxVoltRisePercentPeriod: ?number;
  summermaxVoltRisePhase: ?number;
  summermaxVoltage: ?number;
  summermaxVoltagePhase1: ?number;
  summermaxVoltagePhase2: ?number;
  summermaxVoltagePhase3: ?number;
  summerminVoltage: ?number;
  summerminVoltagePhase1: ?number;
  summerminVoltagePhase2: ?number;
  summerminVoltagePhase3: ?number;
  phaseImpedance: ?number;
  loopImpedance: ?number;
  phaseAllocation: string;
  nodeNumber: number;
  rootTransformerId: string;
}

export class PointOfConnectionProperties implements IPointOfConnectionProperties {
  voltDropPercent: ?number;
  voltRisePercent: ?number;
  loopResistanceMilliohm: ?number;
  includesDownstreamLoad: Boolean;
  includesTransformerResistance: Boolean;
  annotation: string;
  geometry: LatLng;
  styles: any;
  maxVoltDropPercent: ?number;
  maxVoltDropPercentPassResult: Boolean;
  maxVoltRiseTotal: ?number;
  maxVoltRiseGeneration: ?number;
  maxVoltRiseUnbalance: ?number;
  maxVoltRisePercent: ?number;
  earthLoopImpedance: number;
  threePhaseFaultCurrent: number;
  threePhaseFaultCurrentPassResult: Boolean;
  phaseToPhaseFaultCurrent: number;
  phaseToPhaseFaultCurrentPassResult: Boolean;
  singlePhaseToEarthFaultCurrent: number;
  singlePhaseToEarthFaultCurrentPassResult: Boolean;
  flickerPassResult: Boolean;
  flickerDeltaVoltage: number;
  flickerP28Limit: number;
  flickerStartingPassResult: Boolean;
  flickerStartingDeltaVoltage: number;
  impedanceLoopOperating: string;
  impedanceLoopOperatingPassResult: Boolean;
  impedanceSourceLoopOperating: string;
  impedanceSourceLoopOperatingPassResult: Boolean;
  impedanceLoopFault: string;
  impedancePhaseOperating: string;
  impedanceSourcePhaseOperating: string;
  impedanceSourcePhasePhaseOperating: string;
  impedancePhaseFault: string;
  resistanceLoopOperating: string;
  resistanceSourceLoopOperating: string;
  resistanceLoopFault: string;
  resistancePhaseOperating: string;
  resistanceSourcePhaseOperating: string;
  resistanceSourcePhasePhaseOperating: string;
  resistancePhaseFault: string;
  reactanceLoopOperating: string;
  reactanceSourceLoopOperating: string;
  reactanceLoopFault: string;
  reactancePhaseOperating: string;
  reactanceSourcePhaseOperating: string;
  reactanceSourcePhasePhaseOperating: string;
  reactancePhaseFault: string;
  AllmaxVoltDropPercent: ?number;
  AllmaxVoltDropPercentPeriod: ?number;
  AllmaxVoltDropPercentPassResult: Boolean;
  AllmaxVoltDropPhase: ?number;
  AllmaxVoltRisePercent: ?number;
  AllmaxVoltRiseTotal: ?number;
  AllmaxVoltRiseGeneration: ?number;
  AllmaxVoltRiseUnbalance: ?number;
  AllmaxVoltRisePercentPeriod: ?number;
  AllmaxVoltRisePhase: ?number;
  AllmaxVoltage: ?number;
  AllminVoltagePhase1: ?number;
  AllminVoltagePhase2: ?number;
  AllminVoltagePhase3: ?number;
  AllminVoltage: ?number;
  AllmaxVoltagePhase1: ?number;
  AllmaxVoltagePhase2: ?number;
  AllmaxVoltagePhase3: ?number;
  wintermaxVoltDropPercent: ?number;
  wintermaxVoltDropPercentPeriod: ?number;
  wintermaxVoltDropPercentPassResult: Boolean;
  wintermaxVoltDropPhase: ?number;
  wintermaxVoltRisePercent: ?number;
  wintermaxVoltRiseTotal: ?number;
  wintermaxVoltRiseGeneration: ?number;
  wintermaxVoltRiseUnbalance: ?number;
  wintermaxVoltRisePercentPeriod: ?number;
  wintermaxVoltRisePhase: ?number;
  wintermaxVoltage: ?number;
  wintermaxVoltagePhase1: ?number;
  wintermaxVoltagePhase2: ?number;
  wintermaxVoltagePhase3: ?number;
  winterminVoltage: ?number;
  winterminVoltagePhase1: ?number;
  winterminVoltagePhase2: ?number;
  winterminVoltagePhase3: ?number;
  summermaxVoltDropPercent: ?number;
  summermaxVoltDropPercentPeriod: ?number;
  summermaxVoltDropPercentPassResult: Boolean;
  summermaxVoltDropPhase: ?number;
  summermaxVoltRisePercent: ?number;
  summermaxVoltRiseTotal: ?number;
  summermaxVoltRiseGeneration: ?number;
  summermaxVoltRiseUnbalance: ?number;
  summermaxVoltRisePercentPeriod: ?number;
  summermaxVoltRisePhase: ?number;
  summermaxVoltage: ?number;
  summermaxVoltagePhase1: ?number;
  summermaxVoltagePhase2: ?number;
  summermaxVoltagePhase3: ?number;
  summerminVoltage: ?number;
  summerminVoltagePhase1: ?number;
  summerminVoltagePhase2: ?number;
  summerminVoltagePhase3: ?number;
  phaseImpedance: ?number;
  loopImpedance: ?number;
  phaseAllocation: string;
  nodeNumber: number;
  rootTransformerId: string;
  substationId: string;
}
